<template>
  <div class="row center-align" id="homepage">
    <span class="white-text">
      Aby kontynuować musisz się zalogować:
    </span>
    <router-link :to="{ name: 'login' }" >Zaloguj się</router-link>
  </div>
</template>

<script>
export default {
  name: 'home',
  beforeCreate () {
    this.$router.push({ name: 'login' })
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?37c25fee